import React from "react";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Exit from './IntroExit';
import IntroHeader from './IntroHeader';
import SimpleMap from '~app/components/SVG/SimpleMap';
import { useT, useResources } from '~app/BundleProvider';

const Page5 = ({ direction, children, version }) => {
  const t = useT();
  const r = useResources();
  return (
    <div className={`intro-page page-5 ${direction}`}>

      <IntroHeader />
      <Exit />

      <main role="main">

        <SimpleMap ariaLabel={t("page-5-map-label")} page="page-5"/>
        
        {version === "standard"
          ? (
            <React.Fragment>
              <h1 className="intro-headline">{t("community-analysis-feedback")}</h1>
              <img
                src={r("purple-circle-detailed.svg")}
                alt=""
                aria-describedby="image-description"
                className="intro__big-circle purple-circle"
              />
              <div id="image-description" className="sr-only">
                <p>
                  {t("page-5-image-description")}
                </p>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <h1 className="intro-headline">{t("community-analysis-feedback")}</h1>
              <img
                src={r("purple-circle-basic.svg")}
                alt=""
                aria-describedby="image-description"
                className="intro__big-circle purple-circle"
              />
              <div id="image-description" className="sr-only">
                <p>
                  {t("page-5-image-description-simple")}          
                </p>
              </div>
            </React.Fragment>
          )
        }

        {children}

      </main>
    </div>
  );
};

Page5.propTypes = {
  direction: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
};

const mapStateToProps = ({ app }) => ({ version: app.version });

export default connect(mapStateToProps)(Page5);



// WEBPACK FOOTER //
// ./src/pages/intro/Page5.js